import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signout } from '../../../feature/authSlice';
import { btnLogout } from '../../../dataBaseFile/alert';
import { logout } from '../../../service/api/user/logout';
import { store } from '../../../feature/store';
import persistStore from 'redux-persist/es/persistStore';
import { resetState } from '../../../feature/userData/userData';





function LogoutPage(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();


    const onLogout = async () => {
        
        let data = {}
        dispatch(logout(data, () => {
            localStorage.clear("access_token")
            dispatch(resetState())
            dispatch(signout())
        }, () => { 
            localStorage.clear("access_token")
        dispatch(resetState())
        dispatch(signout())
        }))

    };

    return (
        <>
            <button className="dropdown-item ai-icon ms-1 log-btn" onClick={onLogout}>
                <svg xmlns="http://www.w3.org/2000/svg" className="text-primary" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>
                </svg>
                <span className="ms-2 ">{btnLogout}</span>
            </button>
        </>
    )
}
// const mapStateToProps = (state) => {
//     return {
//         isAuthenticated: isAuthenticated(state),
//     };
// };

export default LogoutPage;

// export default withRouter(connect(mapStateToProps)(LogoutPage));